import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: ${(props) => props.backgroundColor};
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const TransportQuoteInfoWrapper = styled.div`
  padding: 1.375rem;
  max-height: 60vh;
  overflow-y: auto;
`;

export const ClientInfoWrapper = styled.div`
  margin-bottom: 1.375rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`;

export const SolutionInfoWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
export const ClientName = styled.div`
  font-family: Lato;
  font-size: 16px;
  line-height: 1;
`;

export const AddressContainer = styled.div`
  margin-bottom: 1.375rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`;

export const AddressLabel = styled.h2`
  margin: 0;
  font-size: 16px;
  text-transform: initial;
  font-family: Lato;
  line-height: 1;
  margin-bottom: 8px;
  color: #004c7f;
`;

export const Address = styled.address`
  font-family: Lato;
  font-size: 1rem;
  line-height: 1;
  margin-bottom: 1rem;
  margin-top: 6px;
  color: #767676;
`;

export const SolutionSummaryWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #979797;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;
  border-left: 4px solid #ff5200;
`;

export const TransportQuotationWrapper = styled(SolutionSummaryWrapper)`
  border-left: 4px solid #1bace4;
`;

export const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 1rem;
`;

export const ThreeColumn = styled.div`
  display: grid;
  gap: 20px;
  margin-bottom: 1rem;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const EditOptionsLabel = styled.h2`
  ${fontStyles}
  color: #1bace4;
  text-transform: initial;
  margin: 0 0 0.563rem 0;
`;

export const EditOptionsDescription = styled.p`
  ${fontStyles}
  color: #000000;
  background-color: transparent;
`;

export const EditOptionsPreDefinedDescription = styled.pre`
  ${fontStyles}
  color: #000000;
  background-color: transparent;
  padding: 0.625rem;
  overflow: auto;
  border: 1px solid #ccc;
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: 300px;
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;
